import React from 'react';
import '../App.css'

const pairings = {
  "experience": "experience",
  "education": "education",
  "map": "Travels",
  "recipes": "Recipes"
}

const NavItem = props => {
  const className = (props.current_state === props.section ? "nav-link active" : "nav-link" )
  return (
    <div style={{cursor:'pointer', textTransform:'capitalize'}} className={className} onClick={() => props.change_state(props.section)}>{pairings[props.section]}</div> 
  );
}


class Navigator extends React.Component {

    render() {
      return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
            <div className="navbar-collapse justify-content-center" id="navbarNavAltMarkup">
              <div className="navbar-nav">
                <NavItem current_state={this.props.current_state} section="experience" change_state={this.props.change_state}/>
                <NavItem current_state={this.props.current_state} section="education" change_state={this.props.change_state}/>
                <NavItem current_state={this.props.current_state} section="map" change_state={this.props.change_state}/>
                {/* <NavItem current_state={this.props.current_state} section="recipes" change_state={this.props.change_state}/> */}
              </div>
            </div>
          </div>
        </nav>
      )
    }
}

export default Navigator;